<template>
  <div class="user-org-deals_uod org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <h2 class="oam_page-title">Отчеты, аналитика организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <h3 class="oam_inner-title">Отчет о сделках</h3>

      <div class="oam_filter_oaf">
        <div class="oaf_cells oaf_cells-1">
          <div class="oaf_cell">
            <org-admin-dates
              :date-start.sync="filter.dateStart"
              :date-end.sync="filter.dateEnd"/>
          </div>
        </div>
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell">
            <org-admin-deals-cont-types :contract-types.sync="filter.contracts"/>
          </div>
          <div class="oaf_cell">
            <org-admin-obj-types :obj-types.sync="filter.types"/>
          </div>
        </div>
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell">
            <org-admin-objs :obj-ids.sync="filter.objects"/>
          </div>
          <div class="oaf_cell">
            <org-admin-users :user-ids.sync="filter.users"/>
          </div>
        </div>
        <div class="oaf_submits">
          <button class="vivid-button" @click="fetchData">
            Сформировать отчет</button>
          <button class="trans-btn" @click="clearReportForm">
            Очистить</button>
        </div>
      </div>

      <div class="oam_cols">
        <div class="oam_col">
          <org-admin-sum
            firstTitle="Сделок всего"
            v-if="objsContractsSum && objsContractsSum.length"
            :data="objsContractsSum"/>
        </div>
        <div class="oam_col">
          <org-admin-sum
            firstTitle="Объектов со сделками"
            v-if="objsDealsSum && objsDealsSum.length"
            :data="objsDealsSum"/>
        </div>
      </div>

    </div>

    <div class="page-container_pcr pcr--xl">

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="fetchData"
        layout="prev, pager, next, jumper"/>

      <div class="data-table_dta" v-if="tableData && tableData.length">
        <table>
          <thead>
            <tr>
              <th>№</th>
              <th>Дата операции</th>
              <th>Объект</th>
              <th>Организации-правообладатели</th>
              <th>Цена</th>
              <th>Тип сделки</th>
              <th>Инициатор сделки</th>
              <th>Организация инициатора сделки</th>
              <th>Код сделки</th>
              <th>Ссылка на сертификат об операциях с ЦОАП</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(o, i) in tableData" :key="`row-${i}`">
              <td class="text-center">{{ ((pager.curPage - 1 ) * pager.pageSize) + i + 1 }}</td>
              <td class="text-center">{{ timeToDate(o.Timestamp) }}</td>
              <td><a :href="`/object/${o.ObjectId}`" target="_blank">
                {{ o.ObjectTitle }}</a></td>
              <td><div v-for="(el, i) in o.Organizations"
                :key="`orgs-${i}`">{{ el.Organization }}</div></td>
              <td class="text-center">{{ o.Price }}</td>
              <td class="dta_nowrap text-center">{{ o.ContractName }}</td>
              <td><a :href="`/user/${o.UserId}/profile/view`" target="_blank">
                {{ o.CreatorFio }}</a></td>
              <td>{{ o.CreatorOrganizationName }}</td>
              <td class="dta_nowrap text-center">{{ o.DealId }}</td>
              <td><a :href="`/object/${o.ObjectId}/certificate`"
                target="_blank">{{ o.ObjectId }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="fetchData"
        layout="prev, pager, next, jumper"/>

    </div>

    <div class="oam_vault" v-if="tableData && tableData.length && vaultText">
      <div class="page-container_pcr">
        <div class="oam_doc-lnk" @click="print('pdf')">
          <img src="/static/grx/icons/docs/pdf.svg" class="oam_doc-lnk-icon">
          <div class="oam_doc-lnk-txt">Скачать в формате PDF</div>
        </div>
        <div class="oam_doc-lnk" @click="print('xls')">
          <img src="/static/grx/icons/docs/xls.svg" class="oam_doc-lnk-icon">
          <div class="oam_doc-lnk-txt">Скачать в формате XLS</div>
        </div>
        <div class="oam_vault-info">
          {{ vaultText }}
        </div>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import OrgAdminLayoutMixin from '@/components/layouts/org-admin/UserOrgLayoutMixin';

export default {

  mixins: [OrgAdminLayoutMixin],

  data() {
    return {
      objsContractsSum: [],
      objsDealsSum: [],
      reportsTotal: 3,
      filterDefaults: {
        dateStart: '',
        dateEnd: '',
        types: [],
        contracts: [],
        objects: [],
        users: [],
        limit: 20,
        offset: 0,
      },
    };
  },

  methods: {
    fetchData() {
      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не удалось определить организацию.');
        return;
      }
      this.reportsLoaded = 0;
      Vue.$loading.on();
      const params = this.getParams();

      axios.post(`organizations/${orgId}/objects/contracts/summary`, params).then((r) => {
        this.objsContractsSum = r.data;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении общей статистики сделок.');
      });

      axios.post(`organizations/${orgId}/objects/deals/summary`, params).then((r) => {
        this.objsDealsSum = r.data;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении общей статистики сделок.');
      });

      this.activeRequest = {
        dataKey: 'ObjectsDeals',
        url: `organizations/${orgId}/objects/deals`,
        params,
      };
      axios.post(this.activeRequest.url, this.activeRequest.params).then((r) => {
        this.tableData = r.data.ObjectsDeals;
        this.pager.total = r.data.Found;
        this.vaultText = `Данные сгенерированны системой IPUniversity ${r.data.ResponseTime}`;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.tableData = [];
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении данных по сделкам объектов.');
      });
    },
  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrgDeals.vue